import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { TbLock } from "react-icons/tb";
import { IoIosArrowDown } from "react-icons/io";
import { MdOutlineMenu } from "react-icons/md";
import { FaInstagram, FaFacebookF } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import {
  HeaderLanguage,
  HoverMenuLinks,
  HoverMenuPages,
  HoverOpenMenu,
  IconsDiv,
  LangImg,
  LanguageDiv,
  MainMenuDiv,
  MenuLinks,
  MenuLinksResp,
  MenuPages,
  MenuTwoParts,
  NameOfAPerson,
  PagesDiv,
  RespMenuDiv,
  RespMenuIcon,
} from "./styled";

import am from "../../assets/images/lang/am.png";
import en from "../../assets/images/lang/en.png";
import ru from "../../assets/images/lang/ru.png";

export const Menu = () => {
  const loc = useLocation();
  const { t, i18n } = useTranslation();

  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("lang") || "en"
  );
  const [openLang, setOpenLang] = useState(false);
  const [hoverMenu, setHoverMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [openResMenu, setOpenResMenu] = useState(false);
  const [openRespHoverMenu, setOpenRespHoverMenu] = useState(false);

  // --- Синхронизация языка при загрузке ---
  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
  }, [selectedLanguage, i18n]);

  // --- Скролл ---
  useEffect(() => {
    const handleScroll = () => {
      if (!openResMenu) setScrolled(window.scrollY > 70);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [openResMenu]);

  const languages = [
    { code: "am", src: am },
    { code: "ru", src: ru },
    { code: "en", src: en },
  ];

  const pages = [
    { pageName: t("Home"), path: "/", activ: loc.pathname === "/", show: true },
    {
      pageName: (
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {t("Paintings")} <IoIosArrowDown color="white" />
        </div>
      ),
      hover: true,
      show: true,
    },
    { pageName: t("About"), path: "/about", activ: loc.pathname === "/about", show: true },
    { pageName: t("Contact"), path: "/contact", activ: loc.pathname === "/contact", show: true },
  ];

  const hoverMenuPages = [
    { pageName: t("Paintings"), path: "/paintings", activ: true },
    { pageName: t("PaintingsSold"), path: "/paintings/sold", activ: true },
    { pageName: t("WallArt"), path: "/wall-art", activ: true },
    { pageName: t("Daily scathes"), path: "/daily-scathes", activ: false },
    { pageName: t("NFT"), path: "/nft", activ: false },
  ];

  const socialLinks = {
    fb: { href: "tps://www.facebook.com/share/1GjMPrcozo/?mibextid=wwXIfr", activ: true },
    inst: { href: "https://www.instagram.com/mayyan_artiste?igsh=NTVka21yZ2pvN3Fv", activ: true },
  };

  // --- Функции ---
  const handleSelectLang = (code) => {
    setSelectedLanguage(code);
    localStorage.setItem("lang", code);
    i18n.changeLanguage(code);
    setOpenLang(false);
  };

  const handleOpenResMenu = () => {
    setOpenResMenu((prev) => !prev);
    setOpenLang(false);
    if (window.scrollY === 0) setScrolled((prev) => !prev);
  };

  const closeRespMenu = () => {
    setOpenResMenu(false);
    setScrolled(false);
  };

  const openResHoverMenu = () => setOpenRespHoverMenu((prev) => !prev);

  // --- JSX ---
  return (
    <>
      <RespMenuIcon>
        <MdOutlineMenu onClick={handleOpenResMenu} />
      </RespMenuIcon>

      <MainMenuDiv $scrolled={scrolled}>
        <MenuTwoParts style={{ width: "30%" }}>
          <NameOfAPerson $scrolled={scrolled} to="/" onClick={() => setOpenResMenu(false)}>
            MayYan
          </NameOfAPerson>
        </MenuTwoParts>

        <MenuTwoParts style={{ width: "60%", color: "#101a50" }}>
          {pages.map((e, i) => {
            if (!e.show) return null;
            return (
              <MenuPages $scrolled={scrolled} key={i} $activ={e.activ}>
                <MenuLinks
                  onMouseOver={e.hover ? () => setHoverMenu(true) : null}
                  onMouseOut={e.hover ? () => setHoverMenu(false) : null}
                  to={e.path || "#"}
                  $scrolled={scrolled}
                >
                  {e.pageName}
                  {e.hover && (
                    <HoverOpenMenu
                      open={hoverMenu}
                      onMouseOver={() => setHoverMenu(true)}
                      onMouseOut={() => setHoverMenu(false)}
                    >
                      <PagesDiv open={scrolled}>
                        {hoverMenuPages.map((el, idx) => (
                          <HoverMenuPages
                            key={idx}
                            to={el.activ ? el.path : null}
                            onMouseOver={() => setHoverMenu(true)}
                            onMouseOut={() => setHoverMenu(false)}
                            open={scrolled}
                          >
                            <HoverMenuLinks
                              style={{
                                textDecoration: el.activ ? "none" : "none",
                                cursor: el.activ ? "pointer" : "not-allowed",
                              }}
                            >
                              {el.pageName} {!el.activ && <TbLock />}
                            </HoverMenuLinks>
                          </HoverMenuPages>
                        ))}
                      </PagesDiv>
                    </HoverOpenMenu>
                  )}
                </MenuLinks>
              </MenuPages>
            );
          })}
        </MenuTwoParts>

        <IconsDiv>
          <div onClick={() => setOpenLang((prev) => !prev)} style={{ cursor: "pointer" }}>
            {selectedLanguage.toUpperCase()}
          </div>
          {openLang && (
            <LanguageDiv scrolled={scrolled}>
              {languages.map((lang) => (
                <HeaderLanguage key={lang.code} onClick={() => handleSelectLang(lang.code)}>
                  <LangImg src={lang.src} />
                </HeaderLanguage>
              ))}
            </LanguageDiv>
          )}
          {socialLinks.fb.activ && (
            <Link to={socialLinks.fb.href} target="_blank">
              <FaFacebookF />
            </Link>
          )}
          {socialLinks.inst.activ && (
            <Link to={socialLinks.inst.href} target="_blank">
              <FaInstagram />
            </Link>
          )}
        </IconsDiv>
      </MainMenuDiv>

      <div style={{ width: "100%", height: "140px", position: "absolute" }} />

      <RespMenuDiv $openResMenu={openResMenu}>
        {pages.map((e, i) => {
          if (!e.show) return null;
          return (
            <div key={i}>
              <MenuLinksResp
                to={e.hover ? "#" : e.path}
                onClick={e.hover ? openResHoverMenu : closeRespMenu}
                $openResMenu={openResMenu}
                style={{ textDecoration: !e.activ ? "none" : "underline" }}
              >
                <span>{e.pageName}</span>
              </MenuLinksResp>

              {e.hover &&
                openRespHoverMenu &&
                hoverMenuPages.map(
                  (el, idx) =>
                    el.activ && (
                      <MenuLinksResp
                        key={idx}
                        to={el.path}
                        $openResMenu={openResMenu}
                        style={{
                          height: "60px",
                          opacity: "1",
                          textDecoration: el.activ ? "underline" : "none",
                        }}
                      >
                        {el.pageName} {!el.activ && <TbLock />}
                      </MenuLinksResp>
                    )
                )}
            </div>
          );
        })}
      </RespMenuDiv>
    </>
  );
};
